import React from 'react';
import PropTypes from 'prop-types';

// Assets
import {black500, greyishBlue100, greyishBlue500} from "assets/jss/main";
import {ReactComponent as CloseIcon} from "assets/img/wms/close_medium.svg";
import PageTitle from "../../../Mobile/PageTitle";
import {Grid} from "@mui/material";

RightDrawerDesktopHead.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    customHeaderPadding: PropTypes.string,
    onClose: PropTypes.func,
    withoutBorder: PropTypes.bool,
    hideCloseIcon: PropTypes.bool,
    closeIconTop: PropTypes.number,
    closeIconRight: PropTypes.number
};

function RightDrawerDesktopHead({
                                     title,
                                     subtitle,
                                     customHeaderPadding,
                                     onClose,
                                     children,
                                     withoutBorder = false,
                                     hideCloseIcon = false,
                                     closeIconTop = 48,
                                     closeIconRight = 40
                                 }) {
    return (
        <Grid container direction={'column'} sx={{
            background: '#fff',
            width: '100%',
            position: 'sticky',
            top: 0,
            paddingTop: '48px',
            borderBottom: withoutBorder ? "none" : `1px solid ${greyishBlue100}`,
            zIndex: 1,
        }}>
            {!hideCloseIcon && (
                <Grid item style={{
                    position: 'absolute',
                    top: closeIconTop,
                    right: closeIconRight,
                }}>
                    <CloseIcon onClick={() => onClose()} />
                </Grid>
            )}

            <Grid item>
                <PageTitle
                    title={title}
                    subtitle={subtitle}
                    isDesktop
                    customPadding={customHeaderPadding}
                />
            </Grid>
            {children && (
                <Grid
                    item
                    sx={{
                        paddingX: "32px",
                        marginTop: "20px"
                    }}
                >
                    {children}
                </Grid>
            )}
        </Grid>
    );
}

export default RightDrawerDesktopHead;
